import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { PlatformService } from '@core/services/platform.service';

@Directive({
    selector: '[sticky]',
    standalone: false
})
export class StickyDirective implements OnInit, AfterViewInit, OnDestroy {

  @Input() topSpacing: number = 0;

  private originalOffset!: number;
  private elementWidth!: number;
  private elementHeight!: number;
  private placeholder?: HTMLElement;

  private destroySubject = new Subject<void>();

  constructor(private elementRef: ElementRef,
              private renderer: Renderer2,
              private route: ActivatedRoute,
              private platformService: PlatformService) {}

  ngOnInit() {
/*
    this.route.url
      .pipe(filter(() => this.platformService.isBrowser))
      .pipe(takeUntil(this.destroySubject))
      .subscribe(() => this.unstick())
*/
  }

  ngAfterViewInit() {
    if (!this.platformService.isBrowser) {
      return;
    }
    setTimeout(() => {
      this.originalOffset = this.elementRef.nativeElement.getBoundingClientRect().top;
      this.elementWidth = this.elementRef.nativeElement.offsetWidth;
      this.elementHeight = this.elementRef.nativeElement.offsetHeight;
    }, 100);
  }

  ngOnDestroy() {
    if (this.placeholder) {
      this.placeholder.remove();
    }
    this.destroySubject.next();
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {

    if (!this.platformService.isBrowser) {
      return;
    }

    // Ignore if viewport not high enough
/*    const viewportHeight = window.innerHeight;
    const viewportWidth  = window.innerWidth;
    if (this.elementRef.nativeElement.offsetHeight > viewportHeight || viewportWidth < 992) {
      this.unstick();
      return;
    }*/

    // Ignore if parent has not enough space
    const parentHeight = this.elementRef.nativeElement.parentNode.offsetHeight;
    if (this.elementRef.nativeElement.offsetHeight + 200 >= parentHeight) {
      this.unstick();
      return;
    }

    const windowScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (windowScrollTop > this.originalOffset) {
      this.stick();
    }
    else {
      this.unstick();
    }
  }

  private stick() {
    const parentLeftOffset = this.elementRef.nativeElement.parentNode.getBoundingClientRect().left;
    if (!this.placeholder) {
      this.placeholder = document.createElement('div');
      this.placeholder.style.height = `${this.elementRef.nativeElement.offsetHeight}px`;
      this.elementRef.nativeElement.parentNode.insertBefore(this.placeholder, this.elementRef.nativeElement);
    }
    this.renderer.setStyle(this.elementRef.nativeElement, 'position', 'fixed');
    this.renderer.setStyle(this.elementRef.nativeElement, 'top', `${this.topSpacing}px`);
    this.renderer.setStyle(this.elementRef.nativeElement, 'left', `${parentLeftOffset}px`);
    this.renderer.setStyle(this.elementRef.nativeElement, 'width', `${this.elementWidth}px`);
    this.renderer.setStyle(this.elementRef.nativeElement, 'overflow', `auto`);
    this.renderer.setStyle(this.elementRef.nativeElement, 'max-height', `calc(100% - 100px)`);
  }

  private unstick() {
    if (this.placeholder) {
      this.placeholder.remove();
      this.placeholder = undefined;
    }
    this.renderer.removeStyle(this.elementRef.nativeElement, 'position');
    this.renderer.removeStyle(this.elementRef.nativeElement, 'top');
    this.renderer.removeStyle(this.elementRef.nativeElement, 'left');
    this.renderer.removeStyle(this.elementRef.nativeElement, 'width');
    this.renderer.removeStyle(this.elementRef.nativeElement, 'overflow');
    this.renderer.removeStyle(this.elementRef.nativeElement, 'max-height');
  }

}
